<template>
<div class="app-footer ">
   <div class="row">
      <div class="col s12 yo-align-center white">
         Società Italiana di Pediatria E.T.S. - Via Cavour 58 - 00184 Roma - Codice Fiscale 96147720583 Partita IVA 06299590965
      </div>
   </div>
</div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  }
}
</script>
<style>
.site-footer{
    
}
</style>
